import { Component, Input, OnInit } from '@angular/core';
import { ControlService } from 'src/app/services/control.service';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ExplorerFilterPipe } from 'src/app/explorer-filter.pipe';

@Component({
    selector: 'app-explorer',
    templateUrl: './explorer.component.html',
    styleUrls: ['./explorer.component.css'],
    standalone: true,
    imports: [TranslateModule, CommonModule, FormsModule, ExplorerFilterPipe]
})
export class ExplorerComponent implements OnInit {

  @Input() control: ControlService;

  explorer = {
    search: '',
    files: [],
    paths: []
  };
  searchText: any;

  ngOnInit() {
    window.onbeforeunload = null;
    this.listDir();
  }

  getAbsolutePath() {
    return (this.explorer.paths.join('/')).replace(/\/\/+/g, '/');
  }

  resetPaths(path: string) {
    this.explorer.paths = path.split('/');
  }

  public listDir() {
    const path = this.getAbsolutePath();
    this.explorer.search = path;

    this.control.fslist('/storage/emulated/0/' + path).then((result: any) => {
      this.explorer.files = result.body.map(file => {
        const S_IFDIR = 0o040000;
        return {
          ...file,
          isDirectory: (file.mode & S_IFDIR) === S_IFDIR,
          mtime: file.mtimeMs ? new Date(file.mtimeMs) : null
        };
      });

      console.table("Explorer Files:", this.explorer.files);
    }).catch((err) => {
      throw new Error(err.message);
    });
  }

  get filteredFiles() {
    if (!this.searchText) {
      return this.explorer.files;
    }
    return this.explorer.files.filter(file =>
      file.name.toLowerCase().includes(this.searchText.toLowerCase())
    );
  }

  dirEnter(name: string) {
    if (name) {
      this.explorer.paths.push(name);
    }
    this.listDir();
    this.explorer.search = this.getAbsolutePath();
  }

  dirUp() {
    if (this.explorer.paths.length !== 0) {
      this.explorer.paths.pop();
    }
    this.listDir();
    this.explorer.search = this.getAbsolutePath();
  }

  getFile(file: string) {
    const path = '/storage/emulated/0/' + this.getAbsolutePath() + '/' + file;

    this.control.fsretrieve(path)
      .then((result) => {
        if (result.body) {
          const link = document.createElement('a');
          link.href = result.body.href + '?download';
          link.download = file;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        }
      })
      .catch((err) => {
        throw new Error(err.message);
      });
  }
}
